// src/components/news/NewsDetails.jsx

import React, { useEffect, useRef, useState } from "react";
import "./NewsDetail.css";
import Hrline from "../Hrline";

const API_URL = process.env.REACT_APP_API_URL;

const NewsDetails = ({ id, newsList, onBack, setId }) => {
  const [news, setNews] = useState(null);
  const [otherNews, setOtherNews] = useState([]);
  const sectionRef = useRef(null); // 🔸 Ref to scroll target

  // Scroll to the section's top with offset
  const scrollToSection = () => {
    if (sectionRef.current) {
      const offset = 100; // Adjust offset if needed
      const y =
        sectionRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const current = newsList.find((item) => item.id === id);
    const others = newsList.filter((item) => item.id !== id);
    setNews(current);
    setOtherNews(others);
    scrollToSection(); // Smooth scroll when news changes
  }, [id, newsList]);

  if (!news) return <div className="container my-5">Loading...</div>;

  return (
    <div className="news-detail-wrapper">
      <Hrline />
      <div
        className="container my-5 news-detail-container"
        ref={sectionRef} // 🔸 Attach scroll ref here
      >
        <button
          className="custom-back-button mb-4"
          onClick={() => {
            onBack();
            scrollToSection();
          }}
        >
          ← <span>Back to All News</span>
        </button>

        <div className="row">
          <div className="col-md-8">
            <img
              src={`${API_URL}${news.image}`}
              alt={news.title}
              className="img-fluid my-3 rounded news-detail-image"
            />
            <h1 className="fw-bold news-detail-title py-3">{news.title}</h1>
            <div
              className="news-detail-content"
              dangerouslySetInnerHTML={{ __html: news.description }}
            ></div>
            {news.url && (
              <a
                href={news.url}
                className="news-detail-source-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit Source
              </a>
            )}
          </div>

          <div className="col-md-4">
            <aside className="news-detail-sidebar">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-3">Other News</h5>
                <span
                  className="text-danger fw-semibold news-detail-viewall"
                  onClick={() => {
                    onBack();
                    scrollToSection();
                  }}
                  role="button"
                >
                  View All
                </span>
              </div>
              <ul className="list-unstyled news-detail-sidebar-list">
                {otherNews
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .slice(0, 5)
                  .map((item) => (
                    <li
                      key={item.id}
                      className="news-detail-sidebar-item"
                      onClick={() => setId(item.id)} // ✅ update id via parent
                      role="button"
                    >
                      <div className="d-flex">
                        <img
                          src={`${API_URL}${item.image}`}
                          alt={item.title}
                          className="news-detail-thumb me-3"
                        />
                        <div>
                          <p className="news-detail-item-title">{item.title}</p>
                          <small className="text-muted">
                            {new Date(item.date).toLocaleDateString("en-US", {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            })}
                          </small>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetails;
